import React, { Component } from 'react'
import { connect } from 'react-redux'
import { registerSign } from '../../store/actions/projectActions'
import { Redirect } from 'react-router-dom'
import firebase from "firebase";
import M from 'materialize-css';
import SignaturePad from 'react-signature-pad-wrapper'
import { withRouter } from "react-router";

M.AutoInit();

class RegisterSign extends Component {
  state = {
    signatureurl: null,
    registered: null
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.profile.esign && prevState.registered) {
      M.toast({ html: 'E-sign registered', classes: 'rounded', displayLength: 8000 })
      nextProps.history.push('/')
    }
    return null;
  }

  onClick = e => {
    if (this.signaturePad.isEmpty() === false) {
      this.setState({
        signatureurl: this.signaturePad.toDataURL()
      })
    }
  }


  onRegister = e => {
    let promise = Promise.resolve();
    promise
      .then(this.props.registerSign(this.state.signatureurl))
      .then(firebase.updateProfile({ esign: this.state.signatureurl }))
      .then(this.setState({ registered: true }))
  }

  onDelete = (e) => {
    this.signaturePad.clear()
    this.setState({
      signatureurl: null
    })
  }
  render() {

    const { auth, profile } = this.props


    if (!auth.uid) return <Redirect to={'/signin'} />
    const registerbutton = this.state.signatureurl ? <button className="btn teal lighten-1 z-depth-1" onClick={this.onRegister}>Register</button> : <button className="btn teal lighten-1 z-depth-1" onClick={this.onClick}>OK</button>

    return (
      <div className="grey lighten-5">
        <div className="container">
          <div className="row"></div>

          <div className="row">
            <div className="col s12 m12">
              <h3>Register your e-sign</h3>
              <div>Use your mouse or pad to draw your signature in the canvas below</div>
              <div>You can register only one E-sign</div>
              <div className="card white darken-1">

                <span className="card-title"></span>

                <SignaturePad ref={ref => this.signaturePad = ref} />


              </div>

            </div>

          </div>
          <div className="row">
            <div className="col s2 m2">
              {/* <button className="btn teal lighten-1 z-depth-0 disabled={this.state.signatureurl !== undefined ? true : false}" onClick={this.onClick}>Looks good</button> */}
              {/* <button className="btn teal lighten-1 z-depth-0" onClick={this.onRegister(auth.uid)}>Register</button> */}
              {registerbutton}
            </div>
            <div className="col s4 m4">
              <button className="btn white grey-text lighten-4 z-depth-1" onClick={this.onDelete}>Clear canvas</button>
            </div>
          </div>
          <div className="row">
            {/* <div class="col s3 m3">
              
            </div> */}
          </div>


          <div className="row"></div>
          <div className="row"></div>
          <div className="row"></div>
          <div className="row"></div>
          <div className="row"></div>
          <div className="row"></div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    registerSign: (project) => dispatch(registerSign(project))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterSign));